import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import { SObject } from '@/types';
import { hasSubscription } from '@/composables/useViewer';

import {
  authGuard,
  unauthenticatedGuard,
  supportedSobjectGuard,
} from './guards';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Auth/Register.vue'),
    meta: {
      authenticated: false,
    },
    beforeEnter: unauthenticatedGuard,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Auth/Login.vue'),
    meta: {
      authenticated: false,
    },
    beforeEnter: unauthenticatedGuard,
  },
  {
    path: '/password/reset/request',
    name: 'password-reset-request',
    component: () => import('@/views/Auth/PasswordResetRequest.vue'),
    meta: {
      authenticated: false,
    },
    beforeEnter: unauthenticatedGuard,
  },
  {
    path: '/password/reset/submit',
    name: 'password-reset-submit',
    component: () => import('@/views/Auth/PasswordResetSubmit.vue'),
    props: (route) => {
      return {
        token: route.query.token ?? '',
      };
    },
    meta: {
      authenticated: false,
    },
    beforeEnter: unauthenticatedGuard,
  },
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/Home.vue'),
    children: [
      {
        path: 'data',
        component: () => import('@/views/Data/Data.vue'),
        children: [
          {
            path: '',
            name: 'data',
            component: () => import('@/views/Data/RecordsWrapper.vue'),
            props: (route) => {
              return {
                sobject: route.query.sobject ?? SObject.ProductRule,
              };
            },
            beforeEnter: supportedSobjectGuard,
          },
        ],
      },
      {
        path: 'metadata/validation',
        name: 'metadata.validation',
        component: () => import('@/views/Metadata/Validation.vue'),
      },
      {
        path: 'metadata/deploy',
        name: 'metadata.deploy',
        component: () => import('@/views/Metadata/PickListValues.vue'),
      },
      {
        path: 'metadata/security',
        name: 'metadata.security',
        component: () => import('@/views/Metadata/FieldLevelSecurity.vue'),
      },
      {
        path: 'duplicates',
        name: 'duplicates',
        component: () => import('@/views/Duplicates/Duplicates.vue'),
      },
      {
        path: '/settings/project',
        name: 'setup',
        component: () => import('@/views/Settings/Project/Setup.vue'),
      },
    ],
  },
  {
    path: '/connect',
    name: 'connect',
    component: () => import('@/views/Connect/Connect.vue'),
  },
  {
    path: '/settings/user/change-password',
    name: 'change-password',
    component: () => import('@/views/Settings/User/ChangePassword.vue'),
  },
  {
    path: '/subscription',
    name: 'subscription',
    component: () => import('@/views/Subscription/SubscriptionPage.vue'),
    beforeEnter: (_, __, next) => {
      if (hasSubscription.value) {
        window.location.href = '/apis/payments/customer-portal-session';
        return;
      }
      next();
    },
  },
  {
    path: '/subscription/success',
    name: 'subscription.success',
    component: () => import('@/views/Subscription/SubscriptionSuccess.vue'),
  },
  {
    path: '/subscription/failure',
    name: 'subscription.failure',
    component: () => import('@/views/Subscription/SubscriptionFailure.vue'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/Logout.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(authGuard);

export default router;
